import script from "./leaseItemPage.vue?vue&type=script&setup=true&lang=js"
export * from "./leaseItemPage.vue?vue&type=script&setup=true&lang=js"

import "./leaseItemPage.vue?vue&type=style&index=0&id=8bd1a6ac&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bd1a6ac"]])

export default __exports__